var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6312 28.0489C26.6579 29.7121 24.0982 30.7161 21.3011 30.7161C15.0597 30.7161 10 25.7167 10 19.5495C10 13.3823 15.0597 8.38281 21.3011 8.38281C24.0982 8.38281 26.6579 9.38684 28.6312 11.05C30.6046 9.38684 33.1643 8.38281 35.9613 8.38281C42.2028 8.38281 47.2625 13.3823 47.2625 19.5495C47.2625 25.7167 42.2028 30.7161 35.9613 30.7161C33.1643 30.7161 30.6046 29.7121 28.6312 28.0489Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6328 28.0489C31.0629 26.0007 32.6039 22.9529 32.6039 19.5495C32.6039 16.146 31.0629 13.0982 28.6328 11.05C30.6062 9.38684 33.1659 8.38281 35.9629 8.38281C42.2043 8.38281 47.264 13.3823 47.264 19.5495C47.264 25.7167 42.2043 30.7161 35.9629 30.7161C33.1659 30.7161 30.6062 29.7121 28.6328 28.0489Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6306 28.0496C31.0611 26.0015 32.6023 22.9534 32.6023 19.5497C32.6023 16.1466 31.0616 13.099 28.6318 11.0508C26.2013 13.099 24.6602 16.147 24.6602 19.5507C24.6602 22.9539 26.2009 26.0015 28.6306 28.0496Z",
    fill: "#FF5E00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "var(--input-border)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.c59723b1520b8cc44c7b15ea24088ac5.svg";
export { ForwardRef as ReactComponent };